import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import { Card } from "primereact/card";
import { InputMask } from "primereact/inputmask";

import ModalSeplag from "../../components/ModalSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import useSelecaoAmparoLegal, { SelecaoAmparoLegalRender } from "../../components/SelecaoAmparoLegal";

import { buscarCertidaoAtivaLegada } from "../../service/certidao";
import { pesquisarAll as pesquisarAllEmpresa } from "../../service/empresa";
import { salvarQuitacao, buscarTiposQuitacao, flagPagamentoIntegral } from '../../service/EventoCertidao/Quitacao'


import { classNames, isFormFieldValid, getFormErrorMessage } from "../../config/global";
import Legenda from "./components/Legenda";
import AlertQuitacaoLegada from "./components/AlertQuitacaoLegada"
import AlertQuitacaoCompnesacaoLegada from "./components/AlertQuitacaoCompnesacaoLegada"

const CertidaoQuitacaoForm = ({ idenCertidao, showForm, onClose, dataForm, handleSalvar }) => {

  const amparo = useSelecaoAmparoLegal({ amparos: dataForm.listaAmparoLegal });
  const [existeAutenticacaoLegada, setExisteAutenticacaoLegada] = useState(false);
  const [existeCompensacaoLegada, setExisteCompensacaoLegada] = useState(false);
  const [validaCertidaoLegada, setValidaCertidaoLegada] = useState(null);
  const [listaEmpresa, setListaEmpresa] = useState([]);
  const [listaTipoEventoCertidao, setListaTipoEventoCertidao] = useState([]);
  const [certidao, setCertidao] = useState(null);

  const isAutenticada = certidao && certidao.flagAutenticacao === "S";
  const isAtiva = certidao && (certidao.flagSituacao === "ATIVA" || certidao.flagSituacao === "EMCOMPENSACAO" || certidao.flagSituacao === "EMQUITACAO");

  useEffect(() => {
    buscarCertidaoAtivaLegada(idenCertidao).then((res) => {
      setCertidao(res.certidao)
      setValidaCertidaoLegada(res.validaCertidaoLegada);
    });

    buscarTiposQuitacao().then(res => {
      setListaTipoEventoCertidao(res)
    })
    pesquisarAllEmpresa().then((res) => {
      setListaEmpresa(res);
    });

  }, [idenCertidao]);

  useEffect(() => {
    if (validaCertidaoLegada && validaCertidaoLegada.dataQuitacaoCert && validaCertidaoLegada.flagQuitacao !== "S") {
      setExisteAutenticacaoLegada(true);
    }

    if (validaCertidaoLegada && validaCertidaoLegada.dataCompensCert && validaCertidaoLegada.flagCompensacao !== "S") {
      setExisteCompensacaoLegada(true);
    }
  }, [validaCertidaoLegada]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { ...dataForm, empresa: null },
    validate: (dados) => {
      let erros = {};

      if (dados.dataEventoCertidao === "") {
        erros.dataEventoCertidao = "Data é de preenchimento obrigatório";
      }

      if (!dados.empresa && dados.tipoEventoCertidao.siglTipoEventoCertidao == "QUIT_COMPENSACAO") {
        erros.empresa = "Pessoa Jurídica é de preenchimento obrigatório";
      }

      if ((!dados.valorEvento || dados.valorEventoAnterior === 0) && dados.tipoEventoCertidao.siglTipoEventoCertidao == "QUIT_COMPENSACAO") {
        erros.valorEventoAnterior = "Valor do Evento Anterior é de preenchimento obrigatório";
      }

      if (!dados.valorEvento || dados.valorEvento === 0) {
        erros.valorEvento = "Valor do Evento Executado é de preenchimento obrigatório";
      }

      if ((!dados.valorEvento || dados.valorEventoPos === 0) && dados.tipoEventoCertidao.siglTipoEventoCertidao == "QUIT_COMPENSACAO") {
        erros.valorEventoPos = "Valor do Evento Posterior é de preenchimento obrigatório";
      }

      if (!dados.tipoEventoCertidao) {
        erros.tipoEventoCertidao = "Tipo de quitação é de preenchimento obrigatório"
      }

      return erros;
    },
    onSubmit: (dados) => {
      let dadosBody = {
        ...dados,
        siglaTipoEventoCertidao: dados.tipoEventoCertidao.siglTipoEventoCertidao
      };
      dadosBody.amparoLegal = [...amparo.justificativasSelecionada];

      // let data = new Date(dadosBody.dataEventoCertidao)
      dadosBody.dataEventoCertidao = dados.dataEventoCertidao;


      salvarQuitacao(dadosBody).then((res) => {
        if (handleSalvar) {
          handleSalvar(res);
        }
      });
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onClose();
  };

  const handleImportarAutenticacao = () => {
    formik.setFieldValue("dataEventoCertidao", validaCertidaoLegada.dataQuitacaoCert);
    formik.setFieldValue("descComplemento", validaCertidaoLegada.numrProcessoQuitacao);
  };

  const handleImportarQuitacaoCompensacao = () => {
    formik.setFieldValue("dataEventoCertidao", validaCertidaoLegada.dataCompensCert);
    formik.setFieldValue("descComplemento", validaCertidaoLegada.numrProcessoCompensacao);
    formik.setFieldValue("valorEvento", validaCertidaoLegada.valrCompensado);
  };

  return (
    <ModalSeplag type="NONE" visible={showForm} fechar={handleClose} tamanho={"80em"} titulo={"Registrar Quitação"}>
      <div className="p-col-12">

        <Legenda values={formik.values} isAutenticada={isAutenticada} isAtiva={isAtiva} />

        <form onSubmit={formik.handleSubmit} style={{ marginTop: '20px' }}>
          <div className="p-grid" style={{ paddingTop: "10px" }}>
            <div className="p-col-12 p-md-12 p-grid">
              {
                existeCompensacaoLegada &&
                formik.values.tipoEventoCertidao.siglTipoEventoCertidao == "QUIT_COMPENSACAO" &&
                <AlertQuitacaoCompnesacaoLegada
                  {...formik.values}
                  {...validaCertidaoLegada}
                  handleImportarQuitacaoCompensacao={handleImportarQuitacaoCompensacao}
                />
              }

              {existeAutenticacaoLegada &&
                formik.values.tipoEventoCertidao.siglTipoEventoCertidao != "QUIT_COMPENSACAO" &&
                (
                  <AlertQuitacaoLegada
                    {...formik.values}
                    {...validaCertidaoLegada}
                    handleImportarAutenticacao={handleImportarAutenticacao}
                  />
                )}



              <div className={`p-col-12 ${existeAutenticacaoLegada} p-grid`}>
                <RotuloSeplag obrigatorio nome="Data do Evento" cols="12 4 3">
                  <InputMask
                    id="dataEventoCertidao"
                    name="dataEventoCertidao"
                    mask="99/99/9999"
                    value={formik.values.dataEventoCertidao}
                    placeholder="99/99/9999"
                    slotChar="mm/dd/yyyy"
                    onChange={(e) => formik.handleChange(e)}
                    className={classNames({ "p-invalid": isFormFieldValid("dataEventoCertidao", formik) })}
                  />
                  {getFormErrorMessage("dataEventoCertidao", formik)}
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Forma de Pagamento" cols="12 4 3">
                  <Dropdown
                    name="flagPagamentoIntegral"
                    value={formik.values.flagPagamentoIntegral}
                    optionValue={"code"}
                    optionLabel={"label"}
                    options={flagPagamentoIntegral}
                    onChange={(e) => formik.handleChange(e)}
                    className={classNames({ "p-invalid": isFormFieldValid("flagPagamentoIntegral", formik) })}
                  />
                  {getFormErrorMessage("flagPagamentoIntegral", formik)}
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Tipo Quitação" cols="12 4 3">
                  <Dropdown
                    name="tipoEventoCertidao"
                    value={formik.values.tipoEventoCertidao}
                    optionLabel={"descTipoEventoCertidao"}
                    options={listaTipoEventoCertidao}
                    onChange={(e) => formik.handleChange(e)}
                    className={classNames({ "p-invalid": isFormFieldValid("tipoEventoCertidao", formik) })}
                  />
                  {getFormErrorMessage("tipoEventoCertidao", formik)}
                </RotuloSeplag>

                <RotuloSeplag obrigatorio nome="Valor Quitado" cols="12 6 3">
                  <InputNumber name="valorEvento" value={formik.values.valorEvento} onValueChange={(e) => formik.handleChange(e)} mode="decimal" minFractionDigits={2} className={classNames({ "p-invalid": isFormFieldValid("valorEvento", formik) })} />
                  {getFormErrorMessage("valorEvento", formik)}
                </RotuloSeplag>

                <RotuloSeplag nome="Complemento" cols="12 12 6">
                  <InputText name="descComplemento" value={formik.values.descComplemento} onChange={(e) => formik.handleChange(e)} />
                </RotuloSeplag>
              </div>
            </div>

            <SelecaoAmparoLegalRender {...amparo} />

            <div className="p-col-12 p-md-3">
              <Button
                type="submit"
                label="Salvar"
                disabled={!(isAutenticada && isAtiva) && formik.values.tipoEventoCertidao.siglTipoEventoCertidao == "QUIT_COMPENSACAO"}
              />
            </div>
            <div className="p-col-12 p-md-3">
              <Button type="button" label="Cancelar" icon="pi pi-times" className="p-button-raised p-button-danger" onClick={handleClose} />
            </div>
          </div>
        </form>
      </div>
    </ModalSeplag>
  );
};

export default CertidaoQuitacaoForm;
